import axios from 'axios'
import jwtDecode from 'jwt-decode'
import store from '@/store'

let urlRefresh = process.env.VUE_APP_AUTH_HOST + process.env.VUE_APP_AUTH_REFRESH_PATH
let urlVerify = process.env.VUE_APP_AUTH_HOST + process.env.VUE_APP_AUTH_VERIFY_PATH
let urlLogin = process.env.VUE_APP_AUTH_HOST + process.env.VUE_APP_AUTH_LOGIN_PATH

function saveToken (token) {
  store.state.token = token
  // localStorage.setItem('token', token)
}

function getToken () {
  return store.state.token
  // return localStorage.getItem('token')
}

async function checkToken (path) {
  // const token = localStorage.getItem('token')
  const token = getToken()
  if (token) {
    const data = { 'token': token }
    try {
      await axios.post(urlVerify, data)
    } catch (e) {
      try {
        let response = await axios.post(urlRefresh, data)
        saveToken(response.data.token)
      } catch (e) {
        window.location.replace(urlLogin + path)
      }
    }
  } else {
    window.location.replace(urlLogin + path)
  }
}

function getId () {
  // const token = localStorage.getItem('token')
  const token = getToken()
  if (token) {
    return jwtDecode(token).user_id
  }
  return ''
}

export default {
  checkToken,
  saveToken,
  getId,
  getToken
}
